import { z } from "zod";
import { fullTrim } from "./helper";

export const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;

export const ulidSchema = z.string().regex(ulidRegex, "不正な値です。");

export const descriptionSchema = z
  .string()
  .max(500, "500文字以内で入力してください")
  .transform((val) => fullTrim(val))
  .transform((val) => (val === "" ? undefined : val))
  .optional();

export const userNameSchema = z
  .string()
  .nonempty("ユーザー名は必須です")
  .min(3, "ユーザー名は3文字以上で入力してください")
  .max(50, "ユーザー名は50文字以内で入力してください")
  .transform((val) => fullTrim(val));

export const nameSchema = (label: string, min = 3, max = 50) =>
  z
    .string()
    .transform((val) => val.trim())
    .refine((val) => val.length >= min, {
      message: `${label} は最低 ${min} 文字以上である必要があります`,
    })
    .refine((val) => val.length <= max, {
      message: `${label} は最大 ${max} 文字以内である必要があります`,
    });
